import Home from '../layout/Home.vue';
import drugControl from './drugControl/index';
import feeDispense from './feeDispense/index';
import clinicManagement from './clinicManagement/index';
import member from './member/index';
import outPatient from './outPatient/index';
import global from './global/index';
import statistics from './statistics/index';
import systemSet from './systemSet/index';
import chainManageStatistics from './chainManageStatistics/index';
import memberManagement from './memberManagement/index';

export default [
  {
    // redirect: '/clinic/clinicInfo',
    path: '/outPatient',
    name: 'outPatient',
    label: '门诊',
    component: Home,
    meta: {
      icon: 'icon-nav_icon_menz',
    },
    id: 27,
    children: outPatient,
  },
  {
    // redirect: '/clinic/clinicInfo',
    path: '/global',
    name: 'global',
    label: '公共',
    component: Home,
    meta: {
      icon: 'icon-nav_icon_menz',
    },
    menuHidden: true,
    children: global,
  },
  {
    // redirect: '/clinic/clinicInfo',
    path: '/outPatient',
    name: 'outPatient',
    label: '门诊管理',
    component: Home,
    meta: {
      icon: 'icon-nav_icon_menz',
    },
    id: 27,
    children: outPatient,
  },
  {
    redirect: '/fee/saleDrug',
    path: '/fee',
    name: 'fee',
    label: '收费发药',
    component: Home,
    meta: {
      icon: 'icon-nav_icon_ypgl',
    },
    children: feeDispense,
  },
  {
    redirect: '/drug/info',
    path: '/drug',
    name: 'drug',
    label: '药品管理',
    component: Home,
    meta: {
      icon: 'icon-nav_icon_yaop',
    },
    children: drugControl,
  },
  {
    redirect: '/drug/info',
    path: '/statistics',
    name: 'statistics',
    label: '数据统计',
    component: Home,
    meta: {
      icon: 'icon-nav_icon_tongj',
    },
    children: statistics,
  },
  {
    redirect: '/member/memberList',
    path: '/member',
    name: 'member',
    label: '会员管理',
    component: Home,
    meta: {
      icon: 'icon-nav_icon_huiy',
    },
    children: member,
  },
  {
    path: '/clinic',
    name: 'clinic',
    label: '诊所管理',
    component: Home,
    meta: {
      icon: 'icon-nav_icon_zhens',
    },
    children: clinicManagement,
  },
  {
    path: '/system',
    name: 'system',
    label: '系统管理',
    component: Home,
    meta: {
      icon: 'icon-xitong',
    },
    children: systemSet,
  },
  {
    path: '/manage',
    name: 'manage',
    label: '经营统计',
    component: Home,
    meta: {
      icon: 'icon-tongji',
    },
    children: chainManageStatistics,
  },
  {
    redirect: '/memberManagement/list',
    path: '/memberManagement',
    name: 'memberManagement',
    label: '会员中心',
    component: Home,
    meta: {
      icon: 'icon-huiyuan',
    },
    children: memberManagement,
  },
];
